import * as React from 'react';

const Shield = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={40}
        height={40}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        viewBox="0 0 40 40"
        {...props}
    >
        <path d="m11.402 18.486 3.92 5.57a1.68 1.68 0 0 0 2.73.082l12.55-15.884" />
        <path d="M5.4 2A2.4 2.4 0 0 0 3 4.4v14.4c0 7.7 11.575 16.27 15.509 18.816a2.36 2.36 0 0 0 2.582 0C25.025 35.07 36.6 26.501 36.6 18.8V4.4A2.4 2.4 0 0 0 34.2 2z" />
    </svg>
);
export default Shield;
